import { Breakpoints, styled } from '@volkswagen-onehub/components-core';
import { HTMLAttributes, ReactNode, forwardRef } from 'react';

const StyledSection = styled.section(
  ({ theme }) => `
  margin-bottom: ${theme.size.static510};

    @media (min-width: ${Breakpoints.b960}px) {
        margin-bottom: ${theme.size.static650};
    }
`
);

interface PageSectionProps extends HTMLAttributes<HTMLElement> {
  children: ReactNode;
}

type Ref = HTMLElement | null;

export default forwardRef<Ref, PageSectionProps>(
  ({ children, ...restProps }, ref) => (
    <StyledSection ref={ref} {...restProps}>
      {children}
    </StyledSection>
  )
);
